"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var _core = require("@emotion/core");

var CheckboxSvg = function CheckboxSvg() {
  return (0, _core.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: _utils.A11Y_INLINE_MIN_SIZE,
    focusable: "false",
    "aria-hidden": true
  }, (0, _core.jsx)("path", {
    className: "tick",
    d: "M8 12l3 3 5-6",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDashoffset: "0"
  }));
};

var _default = CheckboxSvg;
exports.default = _default;